import { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";
import Seo from "../components/Seo";
import { requestPasswordReset } from "../lib/api";
import { LOCATIONS } from "../lib/content";

const WB = LOCATIONS["west-branch"];

export default function AccountForgotPassword() {
  const [email, setEmail] = useState("");
  const [state, setState] = useState({ busy: false, error: null, sent: null });

  const submit = async (e) => {
    e.preventDefault();
    setState({ busy: true, error: null, sent: null });
    try {
      const r = await requestPasswordReset(email.trim());
      setState({ busy: false, error: null, sent: r.userMessage });
    } catch (err) {
      setState({ busy: false, error: err.payload?.userMessage || err.message, sent: null });
    }
  };

  return (
    <>
      <Seo title="Reset your password | West Branch Marina" path="/account/forgot-password" noindex />
      <div className="mx-auto max-w-md px-5 py-28 lg:px-10">
        <h1 className="font-display text-4xl font-extrabold tracking-tight text-navy">
          Reset your password
        </h1>
        <p className="mt-3 text-sm text-slate-600">
          Enter the email you booked with and we'll send you a link to set a new password.
        </p>

        <form data-testid="forgot-form" onSubmit={submit} className="mt-8 space-y-4" noValidate>
          {state.error && (
            <p data-testid="forgot-error" role="alert" aria-live="assertive" className="rounded-xl border border-red-300 bg-red-50 p-3 text-sm text-red-800">
              {state.error}
            </p>
          )}
          {/* Identical for a known and an unknown address, on purpose. */}
          {state.sent && (
            <p data-testid="forgot-sent" role="status" aria-live="polite" className="rounded-xl border border-lake/40 bg-lake/[0.07] p-4 text-sm text-navy">
              {state.sent}
            </p>
          )}
          <div>
            <label htmlFor="forgot-email" className="block text-xs font-bold uppercase tracking-wider text-slate-600">
              Email
            </label>
            <input
              id="forgot-email"
              data-testid="forgot-email"
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-2 w-full rounded-xl border border-navy/15 px-4 py-3 text-sm focus:border-lake focus:outline-none focus:ring-2 focus:ring-lake/30"
            />
          </div>
          <button
            type="submit"
            data-testid="forgot-submit"
            disabled={state.busy}
            className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-ember px-7 py-3.5 font-bold text-white hover:bg-ember-hover disabled:opacity-60"
          >
            <Mail className="h-4 w-4" aria-hidden="true" />
            {state.busy ? "Sending…" : "Email me a reset link"}
          </button>
        </form>

        <p className="mt-6 text-sm text-slate-600">
          <Link to="/account/login" data-testid="forgot-login-link" className="font-bold text-lake underline">
            Back to sign in
          </Link>{" "}
          — or call us on{" "}
          <a href={WB.phoneHref} className="inline-flex items-center gap-1 font-bold text-lake underline">
            <Phone className="h-3.5 w-3.5" aria-hidden="true" />
            {WB.phone}
          </a>
          .
        </p>
      </div>
    </>
  );
}
